// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ABSd1","colMin":"styles_colMin__2TVSH"};